<template>
    <div>
      <b-overlay rounded="sm">
        <ValidationObserver ref="searchForm" slim>
          <b-form @submit.prevent="$event => submit()">
            <b-row>
              <b-col md="2">
                <ValidationProvider
                  name="Transport"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    :label="$gettext('Transport')+ '*'"
                    label-class="chr-label"
                    label-for="transport"
                    class="mb-0"
                  >
                    <b-form-select
                      id="transport"
                      v-model="selectedTransport"
                      :options="transportOptions"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="transport"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="transport">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="2">
                <ValidationProvider
                  name="Departure"
                  v-slot="vContext"
                >
                  <b-form-group
                    :label="$gettext('Departure')+ '*'"
                    label-class="chr-label"
                    label-for="departure"
                    class="mb-0"
                  >
                    <b-form-select
                      id="departure"
                      v-model="selectedDeparture"
                      :options="departureOptions"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="departure"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                      </template>
                      </b-form-select>
                      <b-form-invalid-feedback id="departure">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <ValidationProvider
                  name="Destination country"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    :label="$gettext('Destination country')+ '*'"
                    label-class="chr-label"
                    label-for="country"
                    class="mb-0"
                  >
                    <b-form-select
                      id="country"
                      v-model="selectedDestination"
                      :options="destinationOptions"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="country"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="country">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="2">
                <ValidationProvider
                  name="Period"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                  <b-form-group
                    :label="$gettext('Period')+ '*'"
                    label-class="chr-label"
                    label-for="period"
                    class="mb-0"
                  >
                    <b-form-select
                      id="period"
                      v-model="params.month"
                      :options="monthOptions"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="period"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="period">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$gettext('Tour')"
                  label-class="chr-label"
                  label-for="tour"
                  class="mb-0"
                >
                  <b-form-select
                    id="tour"
                    v-model="params.pack"
                    :options="tourOptions"
                    size="sm"
                    aria-describedby="tour"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-0 mb-2">
              <b-col sm="12"><hr></b-col>
              <b-col sm="12" class="d-flex align-items-center justify-content-end">
                <b-button variant="warning" size="sm" type="submit"><b-icon icon="search" /><span class="ml-2" v-translate>Search Tours</span></b-button>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </b-overlay>
    </div>
</template>

<script>
import moment from 'moment'
import { getDeparturePoints, getDestinations, getTours } from 'b2b-common/services/api/cache'
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'
import formMixin from '@/app/private/shared/mixins/search_forms'

export default {
  name: 'SearchForm',
  mixins: [formMixin, validation, toast],
  data () {
    return {
      selectedCurrency: 'EUR',
      params: {
        packageType: 'tour',
        transport: 'bus',
        departure: null,
        destination: null,
        month: null,
        pack: null
      },
      departuresList: [],
      destinationsList: [],
      toursList: []
    }
  },
  computed: {
    transportOptions () {
      return [
        { value: 'flight', text: this.$gettext('Flight') },
        { value: 'bus', text: this.$gettext('Bus') }
      ]
    },
    departureOptions () {
      return this.departuresList.map(el => ({ value: el.id, text: el.name }))
    },
    destinationOptions () {
      return this.destinationsList.map(el => ({ value: el.id, text: el.name }))
    },
    selectedTransport: {
      get () { return this.params.transport },
      set (val) {
        this.params.transport = val
        this.getDeparturesList()
        this.resetList(['destinations', 'tours'])
      }
    },
    selectedDeparture: {
      get () { return this.params.departure },
      set (val) {
        this.params.departure = val
        this.getDestinationsList()
        this.resetList(['tours'])
      }
    },
    selectedDestination: {
      get () { return this.params.destination },
      set (val) {
        this.params.destination = val
        this.getToursList()
      }
    },
    monthOptions () {
      return [...new Set(this.toursList.flatMap(
        el => el.dates.map(date =>
          moment.unix(date).format('YYYY MM')
        )))]
        .sort()
        .map(el => {
          const date = moment(el + ' 01', 'YYYY MM DD')
          return { value: el, text: date.format('MMMM YYYY') }
        })
    },
    tourOptions () {
      return this.toursList.map(el => ({ value: el.id, text: el.name }))
    }
  },
  methods: {
    async getDeparturesList () {
      this.resetList('departures')
      this.addRequest('departures')
      try {
        const res = await getDeparturePoints({
          packageType: this.params.packageType,
          currency: this.selectedCurrency,
          transport: this.selectedTransport
        })
        this.departuresList = res
        if (this.selectedDeparture && !this.valueExistsInList('departures', this.selectedDeparture)) {
          this.resetList(['countries', 'resorts', 'tours', 'months'])
          this.selectedDeparture = null
        }
      } finally {
        this.removeRequest('departures')
      }
      return this.departuresList
    },
    async getDestinationsList () {
      this.resetList('destinations')
      this.addRequest('destinations')
      try {
        let res = []
        if (this.selectedDeparture) {
          res = await getDestinations({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            departure: this.selectedDeparture
          })
        }
        this.destinationsList = res
      } finally { this.removeRequest('destinations') }
      return this.destinationsList
    },
    async getToursList () {
      this.resetList('tours')
      this.addRequest('tours')
      try {
        let res = []
        if (this.selectedDestination) {
          res = await getTours({
            packageType: this.params.packageType,
            currency: this.selectedCurrency,
            transport: this.selectedTransport,
            departure: this.selectedDeparture,
            destination: this.selectedDestination,
            month: null
          })
        }
        this.toursList = res
      } finally { this.removeRequest('tours') }
      return this.toursList
    },
    submit () {
      this.$refs.searchForm.validate().then(success => {
        if (!success) {
          this.addToast({
            title: this.$gettext('Invalid form'),
            message: this.$gettext('Please fill in all required fields!'),
            variant: 'danger'
          })
        } else {
          this.$emit('search', this.params)
        }
      })
    }
  },
  async created () {
    this.departuresList = await getDeparturePoints({
      packageType: this.params.packageType,
      transport: this.params.transport,
      currency: this.selectedCurrency
    })
  }
}
</script>
